import { isVNode as _isVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import { defineComponent, ref, inject } from "vue";
import { championshipPC } from "@/config/homePage";
import { homePageContextKey } from "@/context/home-page";
import useHomePageChampionship, { getCurrentRaceType } from "@/hooks/home-page-championship";
import { BattleMap64, BattleMap16, BattleMap4 } from "@/components/common/battle-map";
import TeamInfoPopup from "@/components/common/team-info-popup";
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export default defineComponent({
  name: "Championship",
  setup() {
    const activeKey = ref(getCurrentRaceType(9));
    const visible = ref(false);
    const currentTeam = ref({});
    const {
      homePageState
    } = inject(homePageContextKey);
    const {
      firstHalf,
      secondHalf,
      handlePaginationChange,
      curPage,
      battleList
    } = useHomePageChampionship(homePageState, activeKey, false);
    const handleTabsChange = nextKey => {
      // 第一项 - 1 不存在的
      const prevItem = championshipPC[homePageState.raceQuartertype][nextKey];
      console.log('prevItem', prevItem);
      if (prevItem) {
        // const openingDate = +new Date(prevItem.endDate).setHours(23, 59, 59); // 获取开放当天 0 点时间
        const now = +new Date();
        if (now < prevItem.startDate) {
          // TODO: 给个提示？
          return;
        }
      }
      firstHalf.value = [];
      secondHalf.value = [];
      activeKey.value = nextKey;
    };
    const handleShowPopup = teamInfo => {
      if (!teamInfo.name) {
        return;
      }
      currentTeam.value = teamInfo;
      visible.value = true;
    };
    const handleClosePopup = () => {
      visible.value = false;
    };
    return () => {
      let _slot;
      return _createVNode("div", {
        "class": "championship"
      }, [_createVNode("div", {
        "class": "championship-tabs"
      }, [_createVNode(_resolveComponent("van-tabs"), {
        "active": activeKey.value,
        "ellipsis": false,
        "onChange": handleTabsChange
      }, _isSlot(_slot = championshipPC[homePageState.raceQuartertype].map((item, index) => _createVNode(_resolveComponent("van-tab"), {
        "key": item.value
      }, {
        title: () => _createVNode("div", {
          "class": ["championship-tabs-tab", activeKey.value === item.value ? "championship-tabs-tab__active" : ""]
        }, [_createVNode("div", {
          "class": "championship-tabs-tab-wrapper"
        }, [_createVNode("div", {
          "class": "championship-tabs-tab-title"
        }, [item.label]), _createVNode("div", {
          "class": "championship-tabs-tab-desc"
        }, [index !== championshipPC[homePageState.raceQuartertype].length - 1 ? item.dateText : item.dateText[homePageState.groupType - 1]]), index !== championshipPC[homePageState.raceQuartertype].length - 1 && _createVNode("img", {
          "class": "championship-tabs-tab-separator",
          "src": require("@/assets/img/m/homePage/tt-tab-divide.png")
        }, null)])])
      }))) ? _slot : {
        default: () => [_slot]
      })]), activeKey.value === 0 && _createVNode(BattleMap64, {
        "zone1Teams": firstHalf.value,
        "zone2Teams": secondHalf.value,
        "onPaginationChange": handlePaginationChange,
        "curPage": curPage.value,
        "onSelect": handleShowPopup,
        "battleList": battleList.value
      }, null), activeKey.value === 1 && _createVNode(BattleMap16, {
        "zone1Teams": firstHalf.value,
        "onSelect": handleShowPopup
      }, null), activeKey.value === 2 && _createVNode(BattleMap4, {
        "zone1Teams": firstHalf.value,
        "onSelect": handleShowPopup,
        "groupType": homePageState.groupType
      }, null), _createVNode(TeamInfoPopup, {
        "visible": visible.value,
        "teamInfo": currentTeam.value,
        "onClose": handleClosePopup
      }, null)]);
    };
  }
});